/* RESPONSIBLE TEAM: team-ml */

import EditorConfig, {
  type PathConfigGenerationParams,
} from 'embercom/objects/visual-builder/configuration/editor';
import { SdrRoutingOutcomePathConfig } from '../path';

export default class SdrRoutingOutcomeEditorConfig extends EditorConfig {
  public readonly isBackgroundOnly = true;

  generatePathConfig({ path, editorState }: PathConfigGenerationParams) {
    return new SdrRoutingOutcomePathConfig({
      path,
      editorState,
      supportsLocalAttributes: this.supportsLocalAttributes,
    });
  }
}
